import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.o5u_1 = call;
        this.p5u_1 = data.i5l_1;
        this.q5u_1 = data.h5l_1;
        this.r5u_1 = data.k5l_1;
        this.s5u_1 = data.j5l_1;
        this.t5u_1 = data.m5l_1;
      }
      v5i() {
        return this.o5u_1;
      }
      bw() {
        return this.v5i().bw();
      }
      w5i() {
        return this.p5u_1;
      }
      x5i() {
        return this.q5u_1;
      }
      z2n() {
        return this.r5u_1;
      }
      v51() {
        return this.s5u_1;
      }
      p5i() {
        return this.t5u_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
